import { Button, ButtonProps, FourFiveColumnContent } from '@/features/shared';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { TaxonomyKey } from '../../TechPartner.interface';
import { TaxonomySummaryBlockProps } from './TaxonomySummaryBlock.interface';
import useStyles from './TaxonomySummaryBlock.styles';

interface TaxonomyColumnProps {
  label?: string;
  values?: string[];
}

interface CompatibilityColumnProps extends ButtonProps {
  columnLabel?: string;
}

const TaxonomyColumn = ({ label, values }: TaxonomyColumnProps) => {
  const classes = useStyles();

  return (
    <>
      <h3 className={classes.taxonomyColumnHeading}>{label}</h3>
      <ul>{values && values.map((value) => <li key={value}>{value}</li>)}</ul>
    </>
  );
};

const CompatibilityColumn = ({
  columnLabel,
  link,
  theme,
  className,
  outlined,
}: CompatibilityColumnProps) => {
  const classes = useStyles({});

  return (
    <>
      <h3 className={classes.taxonomyColumnHeading}>{columnLabel}</h3>
      <Button outlined={outlined} link={link} theme={theme} className={className} />
    </>
  );
};

const TaxonomySummaryBlock = ({ labels, summary, theme }: TaxonomySummaryBlockProps) => {
  const classes = useStyles({});

  const [taxonomyColumns, setTaxonomyColumns] = useState<JSX.Element[] | undefined>(undefined);

  useEffect(() => {
    if (!summary) return;

    let columns: JSX.Element[] = [];
    if (summary.taxonomy?.categories) {
      columns = Object.keys(summary.taxonomy.categories).map((category) => {
        const { label, values } = summary?.taxonomy?.categories?.[category as TaxonomyKey] ?? {};
        return <TaxonomyColumn label={label} values={values} />;
      });
    }

    if (summary.compatibility && summary.compatibility?.href) {
      columns = [
        ...columns,
        <CompatibilityColumn
          columnLabel={labels?.compatibility_label ?? 'Compatibility'}
          theme={theme}
          link={summary.compatibility}
          outlined={summary.compatibility.buttonStyle === 'secondary'}
        />,
      ];
    }

    setTaxonomyColumns(columns?.filter((column) => column));
  }, [summary, theme, labels]);

  const rootClasses = clsx(classes.taxonomyColumns);
  return (
    <>
      {taxonomyColumns && (
        <FourFiveColumnContent
          className={rootClasses}
          columnCount={4}
          columns={taxonomyColumns}
          theme={theme}
        />
      )}
    </>
  );
};

export default TaxonomySummaryBlock;
